import React from 'react';
import View from "react-native-web/dist/exports/View";
import Platform from "react-native-web/dist/exports/Platform";
import StyleSheet from "react-native-web/dist/exports/StyleSheet";
import PropTypes from 'prop-types';
import { a11yProps, getTokensPropType, selectSystemProps, variantProp, viewProps } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
const [selectProps, selectedSystemPropTypes] = selectSystemProps([a11yProps, viewProps]);
const isListItem = element => {
  const elementName = element?.type?.displayName || element?.type?.name;
  // Match our own ListItem, and also, custom list items
  return Boolean(elementName.match(/Item/));
};

/**
 * An unordered List component has a child a ListItem that
 * allows icon, dividers and customized typography
 */
const List = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children,
    showDivider,
    tokens,
    variant,
    accessibilityRole = Platform.select({
      web: 'list',
      default: undefined
    }),
    ...rest
  } = _ref;
  const items = React.Children.map(children, (child, index) => {
    // Pass ListItem-specific props to children (by name so teams can add their own ListItems)
    if (isListItem(child)) {
      return /*#__PURE__*/React.cloneElement(child, {
        showDivider,
        isLastItem: index + 1 === React.Children.count(children),
        tokens,
        variant,
        ...child.props
      });
    }
    return child;
  });
  const content = /*#__PURE__*/_jsx(View, {
    style: styles.list,
    accessibilityRole: accessibilityRole,
    ref: ref,
    ...selectProps(rest),
    children: items
  });
  return Platform.OS === 'web' ? /*#__PURE__*/_jsx("div", {
    style: styles.container,
    children: content
  }) : content;
});
const styles = StyleSheet.create({
  container: {
    display: 'block'
  },
  list: {
    flex: 1,
    flexShrink: 1
  }
});
List.displayName = 'List';
List.propTypes = {
  ...selectedSystemPropTypes,
  tokens: getTokensPropType('List'),
  variant: variantProp.propType,
  children: PropTypes.node,
  /**
   * In case it is not the last item allow display divider
   */
  showDivider: PropTypes.bool
};
export default List;